// Shared session navigation model for Code and Chat sidebars.
// Keeping filtering/grouping here prevents the two shells from drifting while
// each surface can still render its own controls and visual identity.
import { isChatSession, isCodeSession } from './sessionSurface.js';

export function filterSessionsForSurface(sessions = [], { surface = 'code', search = '' } = {}) {
  const predicate = surface === 'chat' ? isChatSession : isCodeSession;
  const q = String(search || '').trim().toLowerCase();
  return sessions.filter(predicate).filter((s) => !q || String(s.name || '').toLowerCase().includes(q));
}

export function groupSessionsByFolder(sessions = []) {
  const grouped = new Map();
  for (const session of sessions) {
    const key = session?.folder_id || '__root__';
    if (!grouped.has(key)) grouped.set(key, []);
    grouped.get(key).push(session);
  }
  return grouped;
}
